import { Command } from '../../../../_base/actionBus/Command';

export class CancelBooking extends Command {
    constructor(public bookingId: number) {
        super();
    }
}